import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi } from '@src/api';
import type { CmApi } from '@src/api';

import { preloaderStore } from '../../preloaderStore';

class Period2PeriodStore {
  period2period: { id: string; name: string }[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    try {
      const response = await cmApi.tableComponentV2.getTableJson({
        fields: ['period_service_code', 'period_code', 'period_service_code_name'],
        hardFilter: [],
        limit: 100,
        offset: 0,
        resource: 'fns_rep.period2period',
      });

      const result = response?.data as unknown as {
        data: { period_service_code: string; period_code: string; period_service_code_name: string }[];
      };

      if (result) {
        runInAction(() => {
          this.period2period = result.data.map((item) => ({
            id: item.period_service_code,
            name: item.period_service_code_name,
          }));
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      preloaderStore.preloader(false);
    }
  };
}

export const period2PeriodStore = new Period2PeriodStore({ api: cmApi });
